import { Badge } from "~/components/ui/badge";

interface BadgeListProps {
  badges: string[];
}

export function BadgeList({ badges }: BadgeListProps) {
  return (
    <div className="flex flex-wrap gap-6">
      {badges.map((badge) => (
        <Badge
          key={badge}
          className="shadow border-neutral-darkest/20 font-normal px-3 py-4"
          variant={"outline"}
        >
          {badge}
        </Badge>
      ))}
    </div>
  );
}
